export const SET_LOGGED_IN_ACCOUNT = "SET_LOGGED_IN_ACCOUNT";